import { useSession } from 'components/auth/useSession'
import { StatusAtendimento, TipoAtendimentoProfissional } from 'graphql/types.generated'
import { Redirect } from 'react-router'
import { useRetificacaoStorage } from 'view/retificacao-atendimento/useJustificativaRetificacaoStorage'

import { AtendimentoModel } from '../detail/model-atendimento'
import { isResponsavelAtendimentoProfissional } from '../util'
import { AtendimentoVacinacaoView } from './AtendimentoVacinacaoView'

interface AtendimentoVacinacaoBaseViewProps {
  atendimento: AtendimentoModel
  isRetificacao?: boolean
}

export function AtendimentoVacinacaoBaseView(props: Readonly<AtendimentoVacinacaoBaseViewProps>) {
  const { atendimento, isRetificacao = false } = props
  const atendimentoProfissional = atendimento?.atendimentoProfissional
  const atendimentoId = atendimento?.id

  const { data: sessao } = useSession()
  const { getRetificacaoStorageValue } = useRetificacaoStorage(atendimentoId)

  const hasAtendimentoProfissional = !!atendimentoProfissional

  const statusInvalido =
    (!isRetificacao && atendimento?.statusAtendimento === StatusAtendimento.ATENDIMENTO_REALIZADO) ||
    atendimento?.statusAtendimento === StatusAtendimento.NAO_AGUARDOU

  const tipoValido = atendimentoProfissional?.tipo === TipoAtendimentoProfissional.VACINACAO

  const { justificativa: justificativaRetificacao } = getRetificacaoStorageValue()
  const semJustificativaRetificacao = isRetificacao && !justificativaRetificacao

  if (statusInvalido || !tipoValido || !hasAtendimentoProfissional || semJustificativaRetificacao) {
    return <Redirect to='/404' />
  }

  if (!isResponsavelAtendimentoProfissional(sessao.acesso, atendimentoProfissional)) {
    return <Redirect to='/403' />
  }

  return (
    <AtendimentoVacinacaoView atendimentoProfissionalId={atendimentoProfissional?.id} isRetificacao={isRetificacao} />
  )
}
